import type { Theme } from '@mui/material';

export const styles = {
  userListFooter: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: theme.colors.neutral[700],
    fontWeight: 600,
  }),
};
